import React from 'react';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  return (
    <div className="page">
      {/* Hero Section */}
      <section className="hero" style={{minHeight: '60vh', paddingTop: 'calc(80px + var(--spacing-xl))'}}>
        <div className="container hero-content">
          <span className="section-label">About SEVENHC</span>
          <h1>Building the Future of Technology</h1>
          <p>We're a team of passionate innovators dedicated to delivering exceptional IT solutions that transform businesses.</p>
        </div>
      </section>

      {/* Our Story */}
      <section className="section">
        <div className="container">
          <div className="grid grid-2" style={{alignItems: 'center', gap: 'var(--spacing-xl)'}}>
            <div className="reveal-left">
              <span className="section-label">Our Story</span>
              <h2>Who We Are</h2>
              <p style={{fontSize: '1.125rem', marginTop: 'var(--spacing-md)'}}>
                Founded with a vision to bridge the gap between business challenges and technology solutions, SEVENHC has grown into a trusted partner for organizations seeking digital transformation.
              </p>
              <p style={{fontSize: '1.125rem'}}>
                Our journey began with a simple belief: that technology should empower businesses, not complicate them. Today, we work with clients across industries, from startups to enterprise organizations, delivering solutions that drive real results.
              </p>
              <p style={{fontSize: '1.125rem'}}>
                What sets us apart is our commitment to understanding your unique challenges and crafting solutions that fit your specific needs. We don't believe in one-size-fits-all approaches—every project is an opportunity to innovate and exceed expectations.
              </p>
            </div>
            
            <div className="reveal-right">
              <div className="card" style={{padding: 'var(--spacing-xl)'}}>
                <h3 style={{color: 'var(--color-blue-light)', marginBottom: 'var(--spacing-md)'}}>Our Mission</h3>
                <p style={{fontSize: '1.125rem', marginBottom: 'var(--spacing-lg)'}}>
                  To empower organizations with innovative technology solutions that drive growth, efficiency, and competitive advantage in an ever-evolving digital landscape.
                </p>
                
                <h3 style={{color: 'var(--color-blue-light)', marginBottom: 'var(--spacing-md)'}}>Our Vision</h3>
                <p style={{fontSize: '1.125rem', margin: 0}}>
                  To be the leading technology partner recognized for delivering transformative solutions that shape the future of business operations worldwide.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="section" style={{backgroundColor: '#0F0F0F'}}>
        <div className="container">
          <div className="grid grid-4">
            <div className="text-center reveal-scale">
              <h2 style={{color: 'var(--color-blue-light)', fontSize: '3.5rem', marginBottom: '0.5rem'}}>50+</h2>
              <h4 style={{color: 'var(--color-white)', marginBottom: '0.5rem'}}>Projects Delivered</h4>
              <p style={{color: 'var(--color-gray-dark)', margin: 0}}>Successfully completed projects across multiple industries</p>
            </div>
            <div className="text-center reveal-scale delay-100">
              <h2 style={{color: 'var(--color-blue-light)', fontSize: '3.5rem', marginBottom: '0.5rem'}}>30+</h2>
              <h4 style={{color: 'var(--color-white)', marginBottom: '0.5rem'}}>Happy Clients</h4>
              <p style={{color: 'var(--color-gray-dark)', margin: 0}}>Trusted by businesses worldwide</p>
            </div>
            <div className="text-center reveal-scale delay-200">
              <h2 style={{color: 'var(--color-blue-light)', fontSize: '3.5rem', marginBottom: '0.5rem'}}>10+</h2>
              <h4 style={{color: 'var(--color-white)', marginBottom: '0.5rem'}}>Years Experience</h4>
              <p style={{color: 'var(--color-gray-dark)', margin: 0}}>Decade of expertise in IT solutions</p>
            </div>
            <div className="text-center reveal-scale delay-300">
              <h2 style={{color: 'var(--color-blue-light)', fontSize: '3.5rem', marginBottom: '0.5rem'}}>24/7</h2>
              <h4 style={{color: 'var(--color-white)', marginBottom: '0.5rem'}}>Support Available</h4>
              <p style={{color: 'var(--color-gray-dark)', margin: 0}}>Always here when you need us</p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Our Values</span>
            <h2 className="section-title">What Drives Us</h2>
          </div>

          <div className="grid" style={{gridTemplateColumns: 'repeat(3, 1fr)', gap: 'var(--spacing-lg)'}}>
            <div className="card reveal-fade hover-lift">
              <div className="card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="m9 12 2 2 4-4"></path>
                </svg>
              </div>
              <h3>Excellence</h3>
              <p>We pursue excellence in every project, ensuring the highest quality standards and attention to detail in our deliverables.</p>
            </div>

            <div className="card reveal-fade hover-lift delay-100">
              <div className="card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"></path>
                  <path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"></path>
                  <path d="M12 2v2"></path>
                  <path d="M12 22v-2"></path>
                </svg>
              </div>
              <h3>Innovation</h3>
              <p>We embrace cutting-edge technologies and creative approaches to solve complex business challenges with modern solutions.</p>
            </div>

            <div className="card reveal-fade hover-lift delay-200">
              <div className="card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <h3>Partnership</h3>
              <p>We believe in building long-term relationships with our clients, working as trusted partners in their success journey.</p>
            </div>

            <div className="card reveal-fade hover-lift delay-300">
              <div className="card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
              </div>
              <h3>Integrity</h3>
              <p>Honesty and transparency guide all our interactions. We deliver on our promises and maintain the highest ethical standards.</p>
            </div>

            <div className="card reveal-fade hover-lift delay-400">
              <div className="card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                </svg>
              </div>
              <h3>Learning</h3>
              <p>We foster a culture of continuous learning, staying ahead of industry trends to bring the best solutions to our clients.</p>
            </div>

            <div className="card reveal-fade hover-lift delay-500">
              <div className="card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"></path>
                </svg>
              </div>
              <h3>Quality</h3>
              <p>Quality is non-negotiable. Every line of code, every design element, every solution meets our rigorous quality standards.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section" style={{backgroundColor: '#0F0F0F'}}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Why Work With Us?</h2>
          </div>

          <div className="grid grid-2" style={{gap: 'var(--spacing-lg)'}}>
            <div className="card reveal-left" style={{display: 'flex', gap: 'var(--spacing-md)', alignItems: 'start'}}>
              <div style={{minWidth: '50px', height: '50px', background: 'linear-gradient(135deg, var(--color-blue-dark), var(--color-blue-light))', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem'}}>✓</div>
              <div>
                <h4>Expert Team</h4>
                <p style={{margin: 0, color: 'var(--color-gray-dark)'}}>Experienced professionals with deep technical expertise and industry knowledge</p>
              </div>
            </div>

            <div className="card reveal-right" style={{display: 'flex', gap: 'var(--spacing-md)', alignItems: 'start'}}>
              <div style={{minWidth: '50px', height: '50px', background: 'linear-gradient(135deg, var(--color-blue-dark), var(--color-blue-light))', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem'}}>✓</div>
              <div>
                <h4>Proven Track Record</h4>
                <p style={{margin: 0, color: 'var(--color-gray-dark)'}}>Successful delivery of 50+ projects with measurable business impact</p>
              </div>
            </div>

            <div className="card reveal-left delay-100" style={{display: 'flex', gap: 'var(--spacing-md)', alignItems: 'start'}}>
              <div style={{minWidth: '50px', height: '50px', background: 'linear-gradient(135deg, var(--color-blue-dark), var(--color-blue-light))', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem'}}>✓</div>
              <div>
                <h4>Agile Methodology</h4>
                <p style={{margin: 0, color: 'var(--color-gray-dark)'}}>Flexible, iterative approach ensuring rapid delivery and continuous improvement</p>
              </div>
            </div>

            <div className="card reveal-right delay-100" style={{display: 'flex', gap: 'var(--spacing-md)', alignItems: 'start'}}>
              <div style={{minWidth: '50px', height: '50px', background: 'linear-gradient(135deg, var(--color-blue-dark), var(--color-blue-light))', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem'}}>✓</div>
              <div>
                <h4>Transparent Communication</h4>
                <p style={{margin: 0, color: 'var(--color-gray-dark)'}}>Regular updates, clear documentation, and open dialogue throughout projects</p>
              </div>
            </div>

            <div className="card reveal-left delay-200" style={{display: 'flex', gap: 'var(--spacing-md)', alignItems: 'start'}}>
              <div style={{minWidth: '50px', height: '50px', background: 'linear-gradient(135deg, var(--color-blue-dark), var(--color-blue-light))', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem'}}>✓</div>
              <div>
                <h4>Scalable Solutions</h4>
                <p style={{margin: 0, color: 'var(--color-gray-dark)'}}>Architecture designed to grow with your business needs and user base</p>
              </div>
            </div>

            <div className="card reveal-right delay-200" style={{display: 'flex', gap: 'var(--spacing-md)', alignItems: 'start'}}>
              <div style={{minWidth: '50px', height: '50px', background: 'linear-gradient(135deg, var(--color-blue-dark), var(--color-blue-light))', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem'}}>✓</div>
              <div>
                <h4>Comprehensive Support</h4>
                <p style={{margin: 0, color: 'var(--color-gray-dark)'}}>Ongoing maintenance and support to ensure long-term success</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section">
        <div className="container">
          <div className="cta-card text-center reveal-fade">
            <h2>Ready to Transform Your Business?</h2>
            <p style={{fontSize: '1.125rem', maxWidth: '700px', margin: '0 auto var(--spacing-lg)'}}>
              Let's discuss how our expertise can help you achieve your technology goals and drive business growth.
            </p>
            <div style={{display: 'flex', gap: 'var(--spacing-md)', justifyContent: 'center', flexWrap: 'wrap'}}>
              <Link to="/contact" className="btn btn-primary">Get Started</Link>
              <Link to="/services" className="btn btn-secondary">View Our Services</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
